import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
  container_days: {
    display: 'flex',
    width: '100%',
  },
}));
